/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContratAlternanceCommunDto
 */
export interface ContratAlternanceCommunDto {
    /**
     * 
     * @type {number}
     * @memberof ContratAlternanceCommunDto
     */
    idcontratAlternanceCommun?: number;
    /**
     * 
     * @type {number}
     * @memberof ContratAlternanceCommunDto
     */
    idcontrat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContratAlternanceCommunDto
     */
    idcontratStatutWalter?: number;
    /**
     * 
     * @type {string}
     * @memberof ContratAlternanceCommunDto
     */
    nomLieu?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAlternanceCommunDto
     */
    denominationSiege?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAlternanceCommunDto
     */
    adresse?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContratAlternanceCommunDto
     */
    idcodePostal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAlternanceCommunDto
     */
    codePostalText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAlternanceCommunDto
     */
    localite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAlternanceCommunDto
     */
    commune?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAlternanceCommunDto
     */
    chefEntreprise?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAlternanceCommunDto
     */
    fonction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAlternanceCommunDto
     */
    numero?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAlternanceCommunDto
     */
    email?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContratAlternanceCommunDto
     */
    dureeSousContrat?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAlternanceCommunDto
     */
    nomReferent?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAlternanceCommunDto
     */
    prenomReferent?: string | null;
}

/**
 * Check if a given object implements the ContratAlternanceCommunDto interface.
 */
export function instanceOfContratAlternanceCommunDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratAlternanceCommunDtoFromJSON(json: any): ContratAlternanceCommunDto {
    return ContratAlternanceCommunDtoFromJSONTyped(json, false);
}

export function ContratAlternanceCommunDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratAlternanceCommunDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcontratAlternanceCommun': !exists(json, 'idcontratAlternanceCommun') ? undefined : json['idcontratAlternanceCommun'],
        'idcontrat': !exists(json, 'idcontrat') ? undefined : json['idcontrat'],
        'idcontratStatutWalter': !exists(json, 'idcontratStatutWalter') ? undefined : json['idcontratStatutWalter'],
        'nomLieu': !exists(json, 'nomLieu') ? undefined : json['nomLieu'],
        'denominationSiege': !exists(json, 'denominationSiege') ? undefined : json['denominationSiege'],
        'adresse': !exists(json, 'adresse') ? undefined : json['adresse'],
        'idcodePostal': !exists(json, 'idcodePostal') ? undefined : json['idcodePostal'],
        'codePostalText': !exists(json, 'codePostalText') ? undefined : json['codePostalText'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
        'commune': !exists(json, 'commune') ? undefined : json['commune'],
        'chefEntreprise': !exists(json, 'chefEntreprise') ? undefined : json['chefEntreprise'],
        'fonction': !exists(json, 'fonction') ? undefined : json['fonction'],
        'numero': !exists(json, 'numero') ? undefined : json['numero'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'dureeSousContrat': !exists(json, 'dureeSousContrat') ? undefined : json['dureeSousContrat'],
        'nomReferent': !exists(json, 'nomReferent') ? undefined : json['nomReferent'],
        'prenomReferent': !exists(json, 'prenomReferent') ? undefined : json['prenomReferent'],
    };
}

export function ContratAlternanceCommunDtoToJSON(value?: ContratAlternanceCommunDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcontratAlternanceCommun': value.idcontratAlternanceCommun,
        'idcontrat': value.idcontrat,
        'idcontratStatutWalter': value.idcontratStatutWalter,
        'nomLieu': value.nomLieu,
        'denominationSiege': value.denominationSiege,
        'adresse': value.adresse,
        'idcodePostal': value.idcodePostal,
        'codePostalText': value.codePostalText,
        'localite': value.localite,
        'commune': value.commune,
        'chefEntreprise': value.chefEntreprise,
        'fonction': value.fonction,
        'numero': value.numero,
        'email': value.email,
        'dureeSousContrat': value.dureeSousContrat,
        'nomReferent': value.nomReferent,
        'prenomReferent': value.prenomReferent,
    };
}

